import { Button } from "@/app/components/shadcn/button";
import { ChevronRight } from "lucide-react";

const ShowAllFeaturesButton = () => {
  const scrollToProductInfo = () => {
    const element = document.getElementById("product-information");
    if (element) {
      const headerHeight = 140;
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top: elementPosition - headerHeight,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="relative flex items-center justify-center mt-4">
      <Button 
        variant="outline" 
        className="rounded-full px-4 sm:px-6"
        onClick={scrollToProductInfo}
      >
        ÜRÜNÜN TÜM ÖZELLİKLERİ
        <ChevronRight size={18} className="sm:w-5 sm:h-5" />
      </Button>
      <div className="absolute left-0 top-1/2 translate-y-1/2 w-full h-px bg-[#e5e5e5] -z-10"></div>
    </div>
  );
};

export default ShowAllFeaturesButton;
